import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createParticipant, CreateParticipantParams} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';

export const useCreateParticipant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateParticipantParams) => createParticipant(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__PARTICIPANTS]});
    },
  });
};
